import React, { useEffect, useRef, useState } from 'react';

import './QuizContainer.css';
import QuizIntro from './QuizIntro/QuizIntro';
import QuizParagraph from './QuizParagraph/QuizParagraph';
import QuizQuestion from './QuizQuestion/QuizQuestion';
import QuizEndScreen from './QuizEndScreen/QuizEndScreen';

const QuizContainer = props => {
	const mounted = useRef(false);
	const themeNames = ["Reading", "Vocabulary", "Grammar", "Comprehension"];
	const themeColors = ["rgb(245, 140, 140)", "rgb(255, 200, 113)", "rgb(224, 156, 255)", "rgb(163, 216, 255)"];
	const optionColors = ["rgb(231, 117, 117)", "rgb(255, 177, 53)", "rgb(209, 125, 247)", "rgb(123, 194, 247)"];
	const [showIntro, setShowIntro] = useState(!!props.quizMode);
	const [currentTheme, setCurrentTheme] = useState(props.quizMode ? props.allBlocks[0].theme : 0);
	const [currentQuiz, setCurrentQuiz] = useState(0);
	const [showParagraph, setShowParagraph] = useState(false);
	const [showQuestion, setShowQuestion] = useState(false);
	const [showClosingAnimation, setShowClosingAnimation] = useState(false);
	const [animation, setAnimation] = useState('flip-vertical');
	const [bgColor, setBGColor] = useState(props.quizMode ? themeColors[props.allBlocks[0].theme] : themeColors[props.selectedTopic-1]);
	const [finalQuestion, setFinalQuestion] = useState(false);
	const [finishQuiz, setFinishQuiz] = useState(false);
	const [showFinalScreen, setShowFinalScreen] = useState(false);
	const [totalCorrectAnswerCount, setTotalCorrectAnswerCount] = useState(0);
	const [perThemeCorrectAnswerCount, setPerThemeTotalCorrectAnswerCount] = useState([0, 0, 0, 0]);

	/*
	---- DUMMY DATA ----
	const  testData = {
		id: 100,
		// script: "L’activité humaine est la principale cause des char?",
		script: "L’activité humaine  est la principale cause des changements climatiques. La population brûle des combustibles fossiles entraînant de nouveaux  records de concentration  des principaux gaz à effet de serre et, depuis longtemps, de vastes étendues de forêts sont déboisées, transformées  en terres agricoles.  Le Centre canadien des services climatiques (CCSC) qui réunit une équipe multidisciplinaire,  dévouée et doté d'une expertise dans une vaste gamme de disciplines liées au climat, collabore avec des partenaires et des intervenants pour appuyer la mise en œuvre du Cadre canadien sur la croissance propre et les changements climatiques.       . Ce Centre s'est donné pour mission d’encourager les Canadiens à mieux s’adapter aux changements climatiques. Il souhaite  y parvenir en leur fournissant des outils qui leur  expliquent  la façon dont le climat évolue et en attirant leur attention sur les  effets que ces  changements climatiques pourraient avoir sur eux et sur ce qui  leur  tient à cœur. Il conseille et propose des ressources pour aider les citoyens à  prendre des décisions éclairées sur le plan climatique.  Ce CCSC  s'efforce à étendre l'accès à ses données qu'il met, régulièrement, à jour pour  être en mesure de répondre aux besoins  changeants des utilisateurs.  Vu  que ces informations sont parfois très techniques, le CCSC offre de la formation et du soutien aux Canadiens qui cherchent à les décoder et ainsi à mieux savoir comment s’accommoder à un climat en évolution. ",
		question: "Quelle est la phrase qui résume le mieux le texte ? ",
		options: ["un minimum de cinq personnes", "tous les étudiants seront divisés ", " seulement les ministres seront divisés en groupes", "il ne peut pas y avoir plus de cinq étudiants"]
	}
	const testData2 = {
		id: 101,
		script: "Bonjour Monsieur  Petit, je vous appelle pour vous dire que je dois annuler notre rendez-vous de ce matin",
		question: "Quelle est la phrase qui corrige le mieux la phrase soulignée dans le texte ",
		options: [ " Pour que notre rendez-vous  soit reporté à une autre date, ", "Pour que notre rendez-vous  soit reportée à une autre date, ", "Pour que notre rendez-vous  soit reporté  une autre date,", "aucune de ces phrases " ]
	}
	const allBlocks = props.quizMode ? [ [testData2, testData2, testData], [testData2,testData2, testData2 ], [testData, testData2], [testData2, testData, testData2] ] : [props.block];
	*/
	const allBlocks = props.quizMode ? [...props.allBlocks] : [props.block];
	const totalQuizzes = allBlocks.length;
	let totalQuestions = allBlocks.length;
	const perThemeTotalQuestions = [0, 0, 0, 0];
	allBlocks.forEach(question => { perThemeTotalQuestions[question.theme] += 1; });

	let optionColor, themeName;
	if (props.quizMode) {
		themeName = themeNames[currentTheme];
		if (currentTheme === 0 || currentTheme === 3) {
			optionColor = optionColors[currentTheme];
		} else optionColor = themeColors[currentTheme]
	} else {
		themeName = themeNames[props.selectedTopic-1];
		optionColor = optionColors[props.selectedTopic-1]
	}

	const readyForQuiz = () => {
		if (props.quizMode) props.startTimer();
		setShowIntro(false);
		setShowFinalScreen(false);
		setAnimation('flip-horizontal');
		setShowParagraph(currentTheme === 0 || currentTheme === 3);
	}

	const startQuizOver = () => {
		setShowFinalScreen(false);
		setCurrentTheme(props.quizMode ? props.allBlocks[0].theme : 0);
		setCurrentQuiz(0);
		setShowQuestion(false);
		readyForQuiz();
		props.startQuizOver();
	}

	const doneWithThisParagraph = () => {
		if (!props.endQuizNow && !showFinalScreen) {
			setShowParagraph(false);
			setAnimation('flip-horizontal');
			setShowQuestion(true);
		}
	}

	const doneWithThisQuestion = () => {
		let animation = 'none';
		let quiz = currentQuiz + 1;
		if (quiz === totalQuizzes) {
			setShowParagraph(false);
			setShowQuestion(false);
			setAnimation('flip-horizontal');
			setShowFinalScreen(true);
			props.quizFinished();
			return null;
		} else animation = 'flip-horizontal';

		setCurrentTheme(allBlocks[quiz].theme);
		setCurrentQuiz(quiz);
		if (!showFinalScreen) setAnimation(animation);
		setShowQuestion(false);
		setShowParagraph(!showFinalScreen && (allBlocks[quiz].theme=== 0 || allBlocks[quiz].theme === 3));
	}

	const countAnswers = () => {
		let tempTotalCorrectAnswerCount = totalCorrectAnswerCount + 1
		setTotalCorrectAnswerCount(tempTotalCorrectAnswerCount)
		let tempArray = perThemeCorrectAnswerCount;
		tempArray[currentTheme]++;
		setPerThemeTotalCorrectAnswerCount(tempArray)
	}

	useEffect(() => {
		if (!showFinalScreen && (currentTheme === 1 || currentTheme === 2)) setShowQuestion(true)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [showQuestion, currentTheme]);     // removing paragraph component from Grammar and Vocabulary

	useEffect(() => {
		if (props.forceShowEndScreen) {
			setShowParagraph(false);
			setShowQuestion(false);
			setCurrentTheme(0);
			setCurrentQuiz(0);
			setAnimation('flip-horizontal');
			setShowFinalScreen(true);
			props.donewithEndScreen();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.forceShowEndScreen]);

	useEffect(() => {
		if (props.quizMode) props.updateQuizStats(currentQuiz + 1, totalQuizzes);
		const finalQuiz = currentQuiz === (totalQuizzes - 1);
		setFinalQuestion(finalQuiz);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [currentQuiz, totalQuizzes])

	useEffect(() => {
		if (finishQuiz || props.endQuizNow) {
			setCurrentTheme(0);
			setCurrentQuiz(0);
			setShowIntro(false);
			setShowQuestion(false);
			setShowParagraph(false);
			setAnimation('quiz-end');
			setFinishQuiz(false);
			setTimeout(() => { props.quizModeFinished() }, 500)
		} else if (animation !== 'none') setTimeout(() => { setAnimation('none') }, 600);  // animation reset
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [animation, finishQuiz, props.endQuizNow]);

	useEffect(() => {
		if (!mounted.current) {
			mounted.current = true;
			if (!showIntro) readyForQuiz();
		} else {
			if (currentTheme < 4) setTimeout(() => { setBGColor(themeColors[currentTheme]) }, 250 );
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [currentTheme]);

	const containerStyle = { animationName: animation, backgroundColor: bgColor }
	const currentBlock = props.quizMode ? allBlocks[currentQuiz] : props.block;
	const intro = (
		<QuizIntro
			readyBtnClicked={quizDifficulty => {
				readyForQuiz();
				props.startQuiz();
				props.changeDifficultyLevel(quizDifficulty);
			}}
		/>
	);

	const paragraph = (
		showParagraph ?
		<QuizParagraph
			difficultyLevel={props.difficultyLevel}
			quizMode={props.quizMode}
			block={currentBlock}
			themeName={themeName}
			maskBGColor={bgColor}
			textBGColor={optionColor}
			startClosingAnimation={() => setShowClosingAnimation(true)}
			endClosingAnimation={() => setShowClosingAnimation(false) }
			doneWithThisParagraph={() => { if (!props.endQuizNow) doneWithThisParagraph() }}
			endQuizNow={props.endQuizNow}
		/>
		: null
	)

	const question = (
		showQuestion ?
			<QuizQuestion
				block={currentBlock}
				quizMode={props.quizMode}
				closeQuiz={() => props.closeQuiz()}
				showScript={currentTheme === 1 || currentTheme === 2}
				finalQuestion={finalQuestion}
				optionsColor={optionColor}
				doneWithThisQuestion={() => { if (!props.endQuizNow && props.quizMode) doneWithThisQuestion() }}
				endQuizNow={props.endQuizNow}
				correctAnswer={() => countAnswers()}
				blockAnswered={val => props.blockAnswered(val)}
			/>
			: null
	);

	const closingAnimation = (
		showClosingAnimation ?
			<div className='closing-quiz-animation'>
				<p>3</p><p>2</p><p>1</p>
			</div>
			: null
	);

	const quizEndScreen = (
		<QuizEndScreen
			totalCorrectAnswerCount={totalCorrectAnswerCount}
			totalQuestions={totalQuestions}
			perThemeCorrectAnswerCount={perThemeCorrectAnswerCount}
			perThemeTotalQuestions={perThemeTotalQuestions}
			elapsedTime={props.elapsedTime}
			startQuizOver={() => {
				props.startNewQuiz();
				readyForQuiz();
				startQuizOver();
			}}
			endQuiz={() => setFinishQuiz(true)}
		/>
	);

	return (
		<div className='quiz-container' style={containerStyle}>
			{showIntro ? intro : null}
			{!showFinalScreen ? paragraph : null}
			{!showFinalScreen ? closingAnimation : null}
			{!finishQuiz && !showFinalScreen && !showIntro ? question : null}
			{showFinalScreen ? quizEndScreen : null}
		</div>
	)
};

export default QuizContainer;
